// The single sign-on test pop-up (design §4): Cognito returns here after the company IdP; the token is checked by
// the API (POST /api/sso-test), which marks the provider tested. The opener (admin console) is told and reloads.
import { useEffect, useState } from "react";
import { CheckCircle2, XCircle } from "lucide-react";
import { apiWithToken } from "../lib/api";
import { finishSsoTest, loadConfig } from "../lib/auth";
import { Button, Spinner } from "../components/ui";
import { Wordmark } from "../components/icons";

let ran: Promise<{ ok: boolean; message: string }> | null = null;

export default function SsoTest() {
  const [r, setR] = useState<{ ok: boolean; message: string } | null>(null);
  useEffect(() => {
    ran ??= (async () => {
      await loadConfig();
      const { error, idToken } = await finishSsoTest();
      if (error || !idToken) return { ok: false, message: error ?? "No sign-in came back" };
      try {
        const d = await apiWithToken<{ email: string; name: string; company: string }>("/sso-test", idToken);
        return { ok: true, message: `Signed in as ${d.name} (${d.email}) through ${d.company}'s single sign-on.` };
      } catch (e) {
        return { ok: false, message: (e as Error).message };
      }
    })();
    ran.then((x) => {
      setR(x);
      window.opener?.postMessage({ type: "ebookme-sso-test", ok: x.ok, message: x.message }, location.origin);
    });
  }, []);
  if (!r) return <Spinner label="Checking the sign-in…" />;
  return (
    <main className="min-h-full flex flex-col items-center justify-center p-6 gap-5 text-center">
      <Wordmark height={22} />
      {r.ok ? <CheckCircle2 className="size-12 text-good" /> : <XCircle className="size-12 text-bad" />}
      <h1 className="text-lg font-semibold">{r.ok ? "Single sign-on works" : "Single sign-on didn't work"}</h1>
      <p className="text-sm text-ink-2 max-w-sm">{r.message}</p>
      <Button onClick={() => window.close()}>Close this window</Button>
    </main>
  );
}
